import type { DetectorOptions } from "i18next-browser-languagedetector";
import { localeFromHostname } from "@pracownik/domain";

const domainDetector = {
  name: "domainDetector",
  lookup(_options: DetectorOptions): string {
    return localeFromHostname(window.location.hostname);
  },
  cacheUserLanguage() {
    // No caching — domain is the source of truth
  },
};

export default domainDetector;
